import keyMirror from 'react-utils/keyMirror';
import { PropertyObjectTypesIds } from 'ui-forms-components/constants/PropertyObjectTypes';
import { UnknownProperties } from 'forms-utils-lib/constants/Properties';
export const PAYMENT_STATUS = keyMirror({
  OPEN: null,
  PENDING: null,
  SUCCEEDED: null,
  FAILED: null,
  CANCELED: null,
  EXPIRED: null,
  PROCESSING: null
});
export const DISABLED_ADD_OPTION_REASONS = {
  INVALID_ROW: 'INVALID_ROW',
  NO_MORE_OPTIONS_REMAINING: 'NO_MORE_OPTIONS_REMAINING'
};
export const PAYMENT_FIELD_IDENTIFIER = `${PropertyObjectTypesIds.UNKNOWN}/${UnknownProperties.PAYMENT_LINK}`;